import { render, staticRenderFns } from "./confirm salary.vue?vue&type=template&id=93b356d8"
import script from "./confirm salary.vue?vue&type=script&lang=js"
export * from "./confirm salary.vue?vue&type=script&lang=js"
import style0 from "./confirm salary.vue?vue&type=style&index=0&id=93b356d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports